import React, { useState } from 'react';
import { useSessionLaunch } from '../lib/useSessionLaunch';
import { PhishPassProvider } from '../context/PhishPassContext';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { LayoutDashboard, Send, FileText, Users, Settings, ScrollText, Shield } from 'lucide-react';
import PhishPassDashboard from '../components/phishpass/PhishPassDashboard';
import CampaignList from '../components/phishpass/CampaignList';
import TemplateList from '../components/phishpass/TemplateList';
import RecipientRiskView from '../components/phishpass/RecipientRiskView';
import PhishPassSettings from '../components/phishpass/PhishPassSettings';
import PhishPassAuditLogs from '../components/phishpass/PhishPassAuditLogs';
import usePageMeta from '../hooks/usePageMeta';

const PhishPassAppContent = () => {
  usePageMeta('Harmony PhishPass', '/favicon.ico');
  const [activeTab, setActiveTab] = useState('dashboard');

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="border-b bg-white">
        <div className="px-6 py-4 flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-red-100 text-red-600 flex items-center justify-center">
            <Shield className="w-5 h-5" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-slate-800">Harmony PhishPass</h1>
            <p className="text-sm text-slate-500">Phishing simulation &amp; security awareness</p>
          </div>
        </div>
      </div>
      <div className="p-6">
        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <TabsList className="mb-6">
            <TabsTrigger value="dashboard" className="gap-1.5" data-testid="tab-dashboard"><LayoutDashboard className="w-4 h-4" />Dashboard</TabsTrigger>
            <TabsTrigger value="campaigns" className="gap-1.5" data-testid="tab-campaigns"><Send className="w-4 h-4" />Campaigns</TabsTrigger>
            <TabsTrigger value="templates" className="gap-1.5" data-testid="tab-templates"><FileText className="w-4 h-4" />Templates</TabsTrigger>
            <TabsTrigger value="risk" className="gap-1.5" data-testid="tab-risk"><Users className="w-4 h-4" />Employee Risk</TabsTrigger>
            <TabsTrigger value="settings" className="gap-1.5" data-testid="tab-settings"><Settings className="w-4 h-4" />Settings</TabsTrigger>
            <TabsTrigger value="audit" className="gap-1.5" data-testid="tab-audit"><ScrollText className="w-4 h-4" />Audit Log</TabsTrigger>
          </TabsList>

          <TabsContent value="dashboard"><PhishPassDashboard /></TabsContent>
          <TabsContent value="campaigns"><CampaignList /></TabsContent>
          <TabsContent value="templates"><TemplateList /></TabsContent>
          <TabsContent value="risk"><RecipientRiskView /></TabsContent>
          <TabsContent value="settings"><PhishPassSettings /></TabsContent>
          <TabsContent value="audit"><PhishPassAuditLogs /></TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

const PhishPassApp = () => {
  // Signed in from the visitor's own session (see useSessionLaunch).
  const { token } = useSessionLaunch();

  return (
    <PhishPassProvider token={token}>
      <PhishPassAppContent />
    </PhishPassProvider>
  );
};

export default PhishPassApp;
